import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import progressGif from '../../images/progress.gif';
import Portability_Drawl_Fps from './Portability_Drawl_Fps';

const Portability_Drawl_Afso = ({ month, year, district, excludeFpsId }) => {
    const [afsoData, setAfsoData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedAfso, setSelectedAfso] = useState(null);
    const [fpsLoading, setFpsLoading] = useState(false);
    const fpsRef = useRef(null);

    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const monthName = monthNames[month - 1];

    useEffect(() => {
        const fetchAfsoData = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_URL_SALE}/api/portabilityDrawl/afsoBlockDrawl`,
                    { params: { month, year, district, excludeFpsId } }
                );
                setAfsoData(response.data);
            } catch (err) {
                console.error(err);
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        if (month && year && district) fetchAfsoData();
    }, [month, year, district, excludeFpsId]);

    const handleAfsoClick = (block) => {
        if (selectedAfso === block) {
            setSelectedAfso(null);
            return;
        }
        setSelectedAfso(null);
        setFpsLoading(true);
        setTimeout(() => {
            setSelectedAfso(block);
            setFpsLoading(false);

            setTimeout(() => {
                if (fpsRef.current) {
                    fpsRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }, 100);
        }, 3000);
    };

    if (loading) return (
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <img src={progressGif} alt="Loading..." width="250" />
        </div>
    );

    if (error) return (
        <div style={{ textAlign: 'center', color: 'red', marginTop: '20px' }}>
            Error fetching AFSO data
        </div>
    );

    if (!afsoData || afsoData.length === 0) return (
        <div style={{ textAlign: 'center', color: 'red', marginTop: '20px' }}>
            No AFSO Data Found
        </div>
    );

    const totals = afsoData.reduce((acc, item) => {
        acc.totalCards += item.totalCards || 0;
        acc.drawlRc += item.drawlRc || 0;
        acc.wheat += item.wheat || 0;
        acc.sugar += item.sugar || 0;
        acc.frice += item.frice || 0;
        acc.sfrice += item.sfrice || 0;
        return acc;
    }, { totalCards: 0, drawlRc: 0, wheat: 0, sugar: 0, frice: 0, sfrice: 0 });

    return (
        <div style={{ marginTop: '20px' }}>
            <table align="center" width="80%" border={1} style={{ borderCollapse: 'collapse' }}>
                <thead>
                    <tr className='tableheader'>
                        <th colSpan={8}>
                            AFSO WISE UNIQUE RC and SALE DETAILS - {district} - {monthName} '{year}
                        </th>
                    </tr>
                    <tr className="tableheader">
                        <th rowSpan={2} style={{ textAlign: 'left', paddingLeft: '8px' }}>Sl. No</th>
                        <th rowSpan={2}>AFSO</th>
                        <th rowSpan={2}>Total Cards</th>
                        <th rowSpan={2}>Drawl Cards</th>
                        <th colSpan={4}>Total Drawl Qty (Kg)</th>
                    </tr>
                    <tr className="tableheader">
                        <th>Wheat</th>
                        <th>Sugar</th>
                        <th>Fortified Sannabiyyam</th>
                        <th>S-Fortified Sannabiyyam</th>
                    </tr>
                </thead>
                <tbody>
                    {afsoData.map((item, index) => (
                        <tr key={index}>
                            <td style={{ textAlign: 'left', paddingLeft: '8px' }}>{index + 1}</td>
                            <td style={{ textAlign: 'left' }}>
                                <a
                                    href="#"
                                    style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}
                                    onClick={() => handleAfsoClick(item.block)}
                                >
                                    {item.block}
                                </a>
                            </td>
                            <td style={{ textAlign: 'right' }}>{item.totalCards}</td>
                            <td style={{ textAlign: 'right' }}>{item.drawlRc}</td>
                            <td style={{ textAlign: 'right' }}>{item.wheat}</td>
                            <td style={{ textAlign: 'right' }}>{item.sugar}</td>
                            <td style={{ textAlign: 'right' }}>{item.frice}</td>
                            <td style={{ textAlign: 'right' }}>{item.sfrice}</td>
                        </tr>
                    ))}
                    <tr className='tableheader'>
                        <td colSpan={2} style={{ textAlign: 'center' }}>Total</td>
                        <td style={{ textAlign: 'right' }}>{totals.totalCards}</td>
                        <td style={{ textAlign: 'right' }}>{totals.drawlRc}</td>
                        <td style={{ textAlign: 'right' }}>{totals.wheat.toFixed(2)}</td>
                        <td style={{ textAlign: 'right' }}>{totals.sugar.toFixed(2)}</td>
                        <td style={{ textAlign: 'right' }}>{totals.frice.toFixed(2)}</td>
                        <td style={{ textAlign: 'right' }}>{totals.sfrice.toFixed(2)}</td>
                    </tr>
                </tbody>
            </table>

            {fpsLoading && (
                <div style={{ textAlign: "center", marginTop: "20px" }}>
                    <img src={progressGif} alt="Loading..." width="250" height="15" />
                </div>
            )}

            {selectedAfso && !fpsLoading && (
                <div ref={fpsRef}>
                    <Portability_Drawl_Fps
                        month={month}
                        year={year}
                        block={selectedAfso}
                        district={district}
                        excludeFpsId={excludeFpsId}
                    />
                </div>
            )}
        </div>
    );
};

export default Portability_Drawl_Afso;
